const anchorScroll = (element) => {
  const stickyHeaderHeight = getStickyHeaderHeight();
  const stickyAd = document.querySelector('[id="WIX_ADS"]')?.clientHeight || 0;
  const mobileToolbar = document.querySelector('[data-hook="mobile-toolbar"]')?.clientHeight || document.querySelector('[data-hook="ricos-editor-toolbars"]')?.clientHeight || 0;
  const fixedElementsOffset = stickyHeaderHeight + stickyAd + mobileToolbar;
  anchorScrollUsingScrollIntoView(element, fixedElementsOffset);
};
const anchorScrollUsingScrollIntoView = (element, fixedElementsOffset) => {
  const { paddingTop, marginTop } = element.style;
  element.style.marginTop = `-${fixedElementsOffset}px`;
  element.style.paddingTop = `${fixedElementsOffset}px`;
  element.scrollIntoView({ behavior: "smooth" });
  element.style.marginTop = marginTop;
  element.style.paddingTop = paddingTop;
};
const getStickyHeaderHeight = () => {
  const header = document.querySelector('[id="SITE_HEADER"]');
  if (!header) {
    return 0;
  }
  const position = getComputedStyle(header).getPropertyValue("position");
  if (position === "fixed" || position === "sticky") {
    return header.clientHeight;
  }
  return 0;
};
const addAnchorTagToUrl = (anchorString) => {
  const url = new URL(window.location.href);
  url.hash = anchorString;
  history.pushState({}, "", url.href);
};
export {
  addAnchorTagToUrl,
  anchorScroll
};
//# sourceMappingURL=anchor.js.map
